import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { NumericFormat } from 'react-number-format';

const PaymentDetail = (props: any) => {
  return (
    <Stack spacing='15px' height={'auto'} p={'15px'}>
      <Typography fontWeight={700} color={'#484848'}>
        入金
      </Typography>
      <Stack mb={'10px'}>
        <Typography color={'#00000080'}>患者ID</Typography>
        <Typography fontWeight={500} color={'#484848'}>
          {(props.paymentDetail && props.paymentDetail.patientno) || '-'}
        </Typography>
      </Stack>
      <Stack mb={'10px'}>
        <Typography color={'#00000080'}>名前</Typography>
        <Typography fontWeight={500} color={'#484848'}>
          {(props.paymentDetail && props.paymentDetail.patientname) || '-'}
        </Typography>
      </Stack>
      <Stack mb={'10px'}>
        <Typography color={'#00000080'}>医師</Typography>
        <Typography fontWeight={500} color={'#484848'}>
          {(props.paymentDetail && props.paymentDetail.doctor) || '-'}
        </Typography>
      </Stack>
      <Stack mb={'10px'}>
        <Typography color={'#00000080'}>日付</Typography>
        <Typography fontWeight={500} color={'#484848'}>
          {(props.paymentDetail && props.paymentDetail.paymentdate) || '-'}
        </Typography>
      </Stack>
      <Stack mb={'10px'}>
        <Typography color={'#00000080'}>担当者</Typography>
        <Typography fontWeight={500} color={'#484848'}>
          {(props.paymentDetail && props.paymentDetail.fullname) || '-'}
        </Typography>
      </Stack>
      <Stack mb={'10px'}>
        <Typography color={'#00000080'}>金額</Typography>
        <Typography fontWeight={500} color={'#484848'}>
          {(props.paymentDetail && (
            <NumericFormat
              displayType='text'
              value={props.paymentDetail.amount}
              thousandSeparator
            />
          )) ||
            '-'}
        </Typography>
      </Stack>
      <Stack mb={'10px'}>
        <Typography color={'#00000080'}>備考</Typography>
        <Typography fontWeight={500} color={'#484848'} whiteSpace={'pre-line'}>
          {(props.paymentDetail && props.paymentDetail.note) || '-'}
        </Typography>
      </Stack>
    </Stack>
  );
};
export default PaymentDetail;
